<template>
    <el-dialog
        :title="title||'网点派单'"
        :visible.sync="sendOrderVisible"
        width="90%"
        class="sendOrderDialog"
        :before-close="beforeClose"
    >
        <div class="dialogBox">
            <div class="sendOrderDialogLeft innerBox">
                <span class="infoTitle">订单信息</span>
                <el-table
                    class="orderInfoTable"
                    ref="orderInfoTable"
                    :data="orderTable"
                    tooltip-effect="dark"
                    max-height="400"
                    border
                    :row-class-name="tableRowClassName"
                    @row-click="orderRowClick"
                    @selection-change="handleOrderInfoSelChange"
                >
                    <el-table-column type="selection" width="36" fixed></el-table-column>
                    <el-table-column prop="orderNo" label="订单号" width="170" show-overflow-tooltip></el-table-column>
                    <el-table-column label="产品品类" width="156" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.netTaskItems[0].itemClassName}}
                        </template>
                    </el-table-column>
                    <el-table-column label="品牌" width="150" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.netTaskItems[0].brand}}
                        </template>
                    </el-table-column>
                    <el-table-column label="产品型号" width="156" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.netTaskItems[0].itemName}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="address" label="客户地址" width="362" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span>
                                {{scope.row.netTaskAddress.receiverProvinceName||'-'}} /
                                {{scope.row.netTaskAddress.receiverCityName||'-'}} /
                                {{scope.row.netTaskAddress.receiverDistrictName||'-'}} /
                                {{scope.row.netTaskAddress.receiverTownName||'-'}}
                                {{scope.row.netTaskAddress.receiverDetailAddr || ''}}
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="sendOrderDialogRight innerBox">
                <div class="infoTitle">
                    网点信息
                    <div class="infoTools">
                        <el-select v-model="networkSearchType" placeholder="请选择" @change="searchChange">
                            <el-option label="网点名称" value="netName"></el-option>
                            <el-option label="网点编码" value="netCode"></el-option>
                        </el-select>
                        <el-input
                            v-model.trim="networkSearchInput"
                            placeholder="请输入"
                            class="searchText"
                            clearable
                            @clear="resetNetworkList"
                            @keyup.enter.native="getNetwrokList"
                        ></el-input>
                        <el-button type="primary" @click="getNetwrokList">确定</el-button>
                        <el-button @click="resetNetworkList">重置</el-button>
                    </div>
                </div>

                <el-table
                    class="networkInfoTable"
                    ref="networkInfoTable"
                    :data="networkTable"
                    tooltip-effect="dark"
                    highlight-current-row
                    border
                    max-height="400"
                    @row-click="networkRowClick"
                    v-loading="loading"
                >
                    <el-table-column
                        prop="netCenterName"
                        label="分中心"
                        width="182"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column prop="netCode" label="网点编码" width="125" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="netName" label="网点名称" width="252" show-overflow-tooltip></el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination
                        @current-change="pageChange"
                        @size-change="sizeChange"
                        :current-page.sync="pageParams.pageNo"
                        :page-sizes="[10, 30, 50]"
                        :page-size="pageParams.pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next"
                        :total="totalCount"
                    ></el-pagination>
                </div>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="beforeClose">取 消</el-button>
            <el-button type="primary" @click="sendOut">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import api from '../../../../api/netTaskManage2c';
import _ from 'lodash';

export default {
    data() {
        return {
            loading: false,
            sendOrderVisible: false,
            isReassignment: 'N',
            // order
            title: '网点派单',
            orderSearchType: 'orderNo',
            orderSearchInput: '',
            orderTable: [],
            orderSelected: [],
            originLength: 0,
            // network
            networkSearchType: 'netName',
            networkSearchInput: '',
            networkTable: [],
            networkSelected: {},
            totalCount: 0,
            searchParams: {},
            pageParams: {
                pageNo: 1,
                pageSize: 10
            }
        };
    },
    methods: {
        tableRowClassName({ row }) {
            if (
                this.orderSelected &&
                this.orderSelected
                    .map((item) => item.orderNo)
                    .includes(row.orderNo)
            ) {
                return 'highlight-row';
            }
        },
        show(changeOrder, selectedRow, allCenter) {
            this.allCenter = allCenter;
            this.sendOrderVisible = true;
            if (changeOrder) {
                this.title = '网点改派';
                this.isReassignment = 'Y';
            }
            this.orderTable = selectedRow;
            this.originLength = selectedRow.length;
            this.networkCenterCode = selectedRow[0].netTaskAddress.networkCenterCode;
            this.getNetwrokList();
            this.$nextTick(() => {
                this.$refs.orderInfoTable.toggleAllSelection(true);
            });
        },
        searchChange() {
            this.networkSearchInput = '';
            this.searchParams = {};
        },
        async getNetwrokList() {
            this.loading = true;
            if (this.networkSearchInput) {
                this.searchParams[this.networkSearchType] = this.networkSearchInput;
            }
            const params = {
                ...this.pageParams,
                ...this.searchParams,
                netCenterCode: this.allCenter ? '' : this.networkCenterCode,
                netStatus: 'Y' };
            await api
                .netList(params)
                .then((res) => {
                    if (res && res.code === '0') {
                        this.networkTable = res.data.list || [];
                        this.totalCount = res.data.totalCount;
                    } else {
                        this.closeDialogOnly();
                    }
                })
                .catch(() => {
                    this.closeDialogOnly();
                });
            this.loading = false;
        },
        pageChange(data) {
            this.pageParams.pageNo = data;
            this.getNetwrokList();
        },
        sizeChange(data) {
            this.pageParams.pageSize = data;
            this.getNetwrokList();
        },
        resetNetworkList() {
            this.networkSearchInput = '';
            this.searchParams = {};
            this.getNetwrokList();
        },
        // 订单选择
        orderRowClick(row) {
            this.$refs.orderInfoTable.toggleRowSelection(row);
        },
        handleOrderInfoSelChange(row) {
            this.orderSelected = row;
        },
        // 网点选择
        networkRowClick(row) {
            this.networkSelected = row;
        },
        async sendOut() {
            if (
                !this.orderSelected.length ||
                !this.networkSelected.netCode
            ) {
                return this.$message.warning('请选择订单及网点');
            }
            this.loading = true;
            const orderList = [];
            this.orderSelected.forEach((item) => {
                orderList.push({
                    orderNo: item.orderNo,
                    networkCode: this.networkSelected.netCode,
                    isReassignment: this.isReassignment
                });
            });
            await api
                .networkBooking(orderList)
                .then((res) => {
                    if (res && res.code === '0') {
                        this.$message.success('操作成功');
                        this.orderTable = _.difference(this.orderTable, this.orderSelected);
                        if (!this.orderTable.length) {
                            this.closeAndRefresh();
                        }
                    }
                })
                .catch(() => {});
            this.loading = false;
        },
        beforeClose() {
            // 处理内容后，则关闭弹窗并刷新
            this.orderTable.length === this.originLength ? this.closeDialogOnly() : this.closeAndRefresh();
        },
        closeDialogOnly() {
            this.$emit('closeDialog', 'sendOrderDialog', false);
        },
        closeAndRefresh() {
            this.$emit('closeDialog', 'sendOrderDialog', true);
        }
    }
};
</script>

<style lang="less">
.sendOrderDialog {
    min-width: 1280px;
    .pagination {
        margin-top: 10px;
        float: right;
    }
    .dialogBox {
        display: flex;
        .el-table__row {
            cursor: pointer;
        }
        .sendOrderDialogLeft {
            width: 55%;
            padding-right: 14px;
            border-right: 1px solid #e9e9e9;
            .orderInfoTable {
                margin-top: 19px;
            }
        }
        .sendOrderDialogRight {
            width: calc(45% - 28px);
            padding-left: 14px;
        }
    }
    .infoTitle {
        font-size: 15px;
    }
    .infoTools {
        display: inline-block;
        margin: 0 0 10px 20px;
        .el-select {
            width: 100px;
            margin-right: 6px;
        }
        .searchText {
            width: 140px;
            margin-right: 6px;
        }
        .el-button {
            margin-left: 0;
            margin-right: 6px;
        }
    }
    .el-table__body tr.current-row > td {
        background-color: #33C9CC;
        color: #fff;
    }
    .el-table__body tr.highlight-row {
        background: #e6f8f9;
    }
}
</style>